'use client';

import { assetUrl } from '@/lib/directus/assetUrl';
import { devLog } from '@/lib/logging';
import { DirectusImage } from '@/types/directus';
import { PropsWithClassName } from '@/types/shared';
import clsx from 'clsx';
import Image from 'next/image';
import React, { useCallback, useState } from 'react';

import './BlogArticleCardImage.scss';

const DEFAULT_WIDTH = 424;

const DEFAULT_HEIGHT = 300;

const PLACEHOLDER_SRC = '/blog-placeholders/article-card-placeholder.jpg';

type Props = PropsWithClassName & {
  data: undefined | DirectusImage;
};

export const BlogArticleCardImage: React.FC<Props> = ({ data, className }) => {
  const [imgSrc, setImgSrc] = useState<undefined | string>(() => {
    const url = assetUrl(data);

    if (url) return url;

    return PLACEHOLDER_SRC;
  });

  const handleImageError = useCallback(() => {
    devLog(`BlogArticleCardImage: image loading error`);

    if (imgSrc === PLACEHOLDER_SRC) {
      devLog(
        `BlogArticleCardImage: image placeholder error; ${PLACEHOLDER_SRC}`
      );

      setImgSrc(undefined);

      return;
    }

    setImgSrc(PLACEHOLDER_SRC);
  }, [imgSrc]);

  if (!imgSrc) return null;

  return (
    <Image
      className={clsx('BlogArticleCardImage', className)}
      src={imgSrc}
      alt='article-card'
      onError={handleImageError}
      placeholder='empty'
      width={DEFAULT_WIDTH}
      height={DEFAULT_HEIGHT}
    />
  );
};
